import { AgentPrefetchProvider } from "@portal/providers/AgentPrefetchProvider";
import { PreviewFilterProvider } from "@portal/providers/PreviewFilterProvider";
import { SystemBannerProvider } from "@portal/providers/SystemBannerProvider";
import { SuretyAccountView } from "@portal/views/agent/account/AccountView";
import { AccountCreateView } from "@portal/views/agent/account/create/AccountCreateView";
import { AccountSubmissionsView } from "@portal/views/agent/accounts/AccountSubmissionsView";
import { WrittenAccountsView } from "@portal/views/agent/accounts/WrittenAccountsView";
import { BondView } from "@portal/views/agent/bond/BondView";
import { BondsView } from "@portal/views/agent/bonds/BondsView";
import { DashboardView } from "@portal/views/agent/dashboard/DashboardView";
import { AgentMainLayout } from "@portal/views/agent/layout/AgentMainLayout";
import { BondRequestRedirect } from "@portal/views/agent/request/BondRequestRedirect";
import { BondRequestView } from "@portal/views/agent/request/BondRequestView";
import { BondRequestCreateView } from "@portal/views/agent/request/create/BondRequestCreateView";
import { RequestsView } from "@portal/views/agent/requests/RequestsView";
import { MyTeamView } from "@portal/views/agent/settings/MyTeamView/MyTeamView";
import { Navigate, Route, Routes } from "react-router-dom";
import { AuthGuard, RBACAuthGuard } from "./utils/guards";

export const AgentApp = () => {
	return (
		<AgentPrefetchProvider>
			<SystemBannerProvider audience="agent">
				<PreviewFilterProvider userType="agent">
					<AgentMainLayout>
						<Routes>
							<Route path="/" element={<AuthGuard component={DashboardView} />} />
							<Route path="requests" element={<AuthGuard component={RequestsView} />} />
							<Route
								path="requests/create"
								element={<AuthGuard component={BondRequestCreateView} />}
							/>
							<Route path="requests/:id" element={<AuthGuard component={BondRequestRedirect} />} />
							<Route
								path="accounts/:accountId/requests/:id"
								element={<AuthGuard component={BondRequestView} />}
							/>
							<Route path="bonds" element={<AuthGuard component={BondsView} />} />
							<Route path="bonds/:id" element={<AuthGuard component={BondView} />} />
							<Route path="accounts/create" element={<AuthGuard component={AccountCreateView} />} />
							<Route path="accounts" element={<AuthGuard component={WrittenAccountsView} />} />
							<Route
								path="submissions"
								element={<AuthGuard component={AccountSubmissionsView} />}
							/>
							<Route path="accounts/:id" element={<AuthGuard component={SuretyAccountView} />} />
							<Route
								path="team"
								element={
									<RBACAuthGuard
										roles={["agent-admin"]}
										rbacRedirectTo="/"
										component={() => <MyTeamView />}
									/>
								}
							/>
							<Route path="*" element={<Navigate to="/" />} />
						</Routes>
					</AgentMainLayout>
				</PreviewFilterProvider>
			</SystemBannerProvider>
		</AgentPrefetchProvider>
	);
};
